<template>
  <div class="content">
    <h1 style="text-align: center">财通企财通隐私政策 20230817-14:00</h1>

    <p>本版发布日期：2022年4月1日&nbsp;</p>

    <p>生效日期：2022年4月1日</p>

    <p>
      财通证券股份有限公司&nbsp;(以下简称&ldquo;我司&rdquo;)深知个人信息对您的重要性，会尽力保护您的个人信息安全。我司致力于维护您对我司的信任，恪守以下原则保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、必要性原则、确保安全原则、公开透明原则等。同时，我司承诺依法采取相应的安全保护措施来保护您的个人信息。<strong>请您在注册前，仔细阅读并确认《隐私政策》。</strong>&nbsp;本《隐私政策》将帮助您了解以下内容&nbsp;：
    </p>

    <p>1.我司如何收集和使用您的个人信息</p>

    <p>2.我司如何使用Cookie和同类技术</p>

    <p>3.关于存储和对外提供您的个人信息</p>

    <p>4.我司如何保护您的个人信息</p>

    <p>5.您控制个人信息的权利</p>

    <p>6.本政策如何更新</p>

    <p>7.如何联系我司</p>

    <p><strong>一、我司如何收集和使用您的个人信息</strong></p>

    <p>
      个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人信息包括姓名、出生日期、身份证件号码、个人生物识别信息、通信通讯联系方式、住址、账户信息、财产状况、行踪轨迹等。其中一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的信息为个人敏感信息，主要包括身份证件号码、个人生物识别信息、银行账号、征信信息、财产信息、&nbsp;交易信息、行踪轨迹等。
    </p>

    <p><strong>（一）我司收集和使用个人信息的原则</strong><strong>&nbsp;</strong></p>

    <p>我司收集使用您的个人信息将遵循合法、正当、必要的原则，按照法律法规要求以及业务需要收集您的个人信息，不会收集与业务无关的信息或采取不正当方式收集信息。</p>

    <p><strong>（二）我司收集和使用个人信息的目的</strong><strong>&nbsp;</strong></p>

    <p><strong>为了遵守中国法律的规定、以及为了向您提供服务并保障您的账号安全与系统运行安全，提升用户使用体验，我们会收集您在使用我们的服务的过程中产生的相关信息，包括：</strong></p>

    <p><strong>1</strong><strong>、手机号码注册</strong></p>

    <p>
      <strong>当您注册使用</strong><strong>财通企财通APP时</strong><strong>，</strong><strong>根据法律法规中关于网络实名制要求，您需要输入手机号码</strong><strong>，我们将通过发送短信验证码来验证您的身份是否有效。如您拒绝提供手机号码验证，将会影响您使用我司软件。</strong>
    </p>

    <p><strong>2</strong><strong>、设备或应用信息</strong></p>

    <p>
      <strong>根据监管要求，证券金融类交易行为需要报送用户登录当前设备的</strong><strong>IP</strong><strong>、</strong><strong>MAC</strong><strong>、</strong><strong>IMEI</strong><strong>、</strong><strong>U</strong><strong>UI</strong><strong>D</strong><strong>、手机号等作为硬件留痕信息。因此，为保障用户账户及交易安全，我们会在用户执行相关操作时，对设备或应用信息包括您的移动设备、网页浏览器或您用于接入我司服务的其他程序所提供的配置信息、您的</strong><strong>IP</strong><strong>地址、无线网络接入信息和您的移动设备所用的版本、硬件型号、设备</strong><strong>MAC</strong><strong>地址、操作系统类型、软件列表唯一设备识别码</strong><strong>(</strong><strong>如</strong><strong>IMEI</strong><strong>、</strong><strong>A</strong><strong>ndroid
        ID</strong><strong>、</strong><strong>IDFA</strong><strong>、</strong><strong>OPENUDID</strong><strong>、</strong><strong>GUID</strong><strong>、</strong><strong>SIM</strong><strong>卡</strong><strong>IMSI</strong><strong>信息等在内的描述个人常用设备基本情况的信息</strong><strong>)</strong><strong>进行转发。即便在未登录状态下，也可以获得便捷流畅的体验，并同样可以进行阅读、查看行情等基础行为。</strong>
    </p>

    <p>
      <strong>除了产品的基本功能外，我们提供一些附加功能来提升用户体验，需要提供以下权限与信息设备权限、位置信息、个人敏感信息。当您使用附加功能时，我们会取得相关权限的同意。您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝我们收集或提供相应的个人信息，也不会影响其他功能的使用。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。</strong>
    </p>

    <p><strong>3</strong><strong>、设备权限</strong></p>

    <p>
      <strong>在提供服务的过程中，可能需要您开通一些设备权限，我们会通过弹窗等方式请求通知、蓝牙、</strong>WiFi<strong>及蜂窝数据的权限、麦克风、相册或手机存储、摄像头，定位信息；在您更换头像或使用图片的上传、保存、识别、编辑功能与分享功能时，会主动提示您获取读写相册或手机存储的权限；在您需要消息内容推送时，会主动提示您获取通知的权限；在您需要使用与访问网络时，会主动提示蓝牙、</strong>WiFi<strong>及蜂窝数据相关权限；在您需要办业务视频见证时，会主动提示麦克风与摄像头的权限；在您开户时为了更方便的给您推荐我司服务，我们会让您开启定位权限</strong><strong>；</strong><strong>在您使用时为了方便拨打客户服务电话，我们会请求拨打电话的权限</strong><strong>。除此之外，苹果系统还有后台</strong>APP<strong>刷新机制、</strong>Siri<strong>与</strong><strong>&nbsp;</strong><strong>搜索的权限，对于此类权限，我们无法收集相关个人信息，您可以查阅苹果公司的相关协议后选择使用与否。</strong>
    </p>

    <p><strong>4</strong><strong>、个人敏感信息</strong></p>

    <p>
      <strong>除了上述的个人敏感信息之外，为了保障您的账户与资金安全，在您进行登录、找回密码、账户与资金相关服务操作时，可能需要提供指纹、面部识别信息及其他个人敏感信息来进行操作，如果使用前述服务需要同意授权我们来获取。</strong>
    </p>

    <p><strong>5</strong><strong>、我们接入的第三方</strong></p>

    <p><strong>为了使您能够接收信息推送、在第三方平台分享信息以及运营统计的需要，我们应用接入了第三方</strong><strong>sdk</strong><strong>或服务，具体第三方信息如下：</strong>
    </p>

    <p><strong>魅族推送</strong><strong>SDK</strong></p>

    <p>应用场景描述：推送信息</p>

    <p>收集的个人信息：访问网络、获取网络信息状态、获取WIFI状态、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务</p>

    <p>信息类型：个人常用设备信息</p>

    <p>共享方式：SDK本机采集</p>

    <p>使用目的：让魅族设备能够收到推送消息</p>

    <p>第三方机构名称：魅族科技有限公司</p>

    <p>隐私协议连接：https://i.flyme.cn/privacy</p>

    <p>官网链接：http://open.flyme.cn/</p>

    <p>&nbsp;</p>

    <p><strong>小米推送</strong><strong>SDK</strong></p>

    <p>应用场景描述：推送信息</p>

    <p>收集的个人信息：访问网络、获取网络信息状态、获取WIFI状态、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务</p>

    <p>信息类型：个人常用设备信息</p>

    <p>共享方式：SDK本机采集</p>

    <p>使用目的：让小米设备能够收到推送消息</p>

    <p>第三方机构名称：北京小米移动软件有限公司</p>

    <p>隐私协议连接：https://dev.mi.com/console/doc/detail?pId=1822</p>

    <p>官网链接：https://dev.mi.com/console/</p>

    <p>&nbsp;</p>

    <p><strong>华为推送</strong><strong>SDK</strong></p>

    <p>应用场景描述：推送信息</p>

    <p>收集的个人信息：访问网络、获取网络信息状态、获取WIFI状态、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务</p>

    <p>信息类型：个人常用设备信息</p>

    <p>共享方式：SDK本机采集</p>

    <p>使用目的：让华为设备能够收到推送消息</p>

    <p>第三方机构名称：华为技术有限公司</p>

    <p>
      隐私协议连接：https://consumer.huawei.com/minisite/cloudservice/hiapp/privacy-statement.htm?code=CN&amp;branchid=2&amp;language=zh_CN
    </p>

    <p>官网链接：https://developer.huawei.com/consumer/cn/</p>

    <p>&nbsp;</p>

    <p><strong>vivo</strong><strong>推送 </strong><strong>SDK</strong></p>

    <p>应用场景描述：推送信息</p>

    <p>收集的个人信息：访问网络、获取网络信息状态、获取WIFI状态、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务</p>

    <p>信息类型：个人常用设备信息</p>

    <p>共享方式：SDK本机采集</p>

    <p>使用目的：让vivo设备能够收到推送消息</p>

    <p>第三方机构名称：维沃移动通信有限公司</p>

    <p>隐私协议连接：https://www.vivo.com.cn/about-vivo/privacy-policy</p>

    <p>官网链接：https://push.vivo.com.cn</p>

    <p>&nbsp;</p>

    <p><strong>oppo</strong><strong>推送 </strong><strong>SDK</strong></p>

    <p>应用场景描述：推送信息</p>

    <p>收集的个人信息：访问网络、获取网络信息状态、获取WIFI状态、读取手机状态、写存储空间、未知应用安装权限、允许应用开启前台服务</p>

    <p>信息类型：个人常用设备信息</p>

    <p>共享方式：SDK本机采集</p>

    <p>使用目的：让oppo设备能够收到推送消息</p>

    <p>第三方机构名称：广东欢太科技有限公司</p>

    <p>隐私协议连接：https://open.oppomobile.com/wiki/doc#id=10288</p>

    <p>官网链接：https://push.oppo.com/</p>

    <p>&nbsp;</p>

    <p><strong>个推（每日互动股份有限公司）推送</strong><strong>&nbsp;</strong><strong>SDK</strong></p>

    <p>应用场景描述：推送信息</p>

    <p>收集的个人信息：设备平台、设备厂商及品牌、设备型号及系统版本、设备识别码、设备序列号，应用列表信息，网络信息</p>

    <p>信息类型：个人常用设备信息</p>

    <p>共享方式：SDK本机采集</p>

    <p>使用目的：让安卓设备能够收到推送</p>

    <p>第三方机构名称：每日互动股份有限公司</p>

    <p>隐私协议连接：http://docs.getui.com/privacy/</p>

    <p>官网链接：<a href="https://www.getui.com/">https://www.getui.com/</a></p>

    <p>&nbsp;</p>

    <p><strong>移动 SDK</strong></p>

    <p>应用场景描述：一键登录</p>

    <p>收集的个人信息：</p>

    <p>Android：访问网络、网络信息状态、WIFI状态、修改WIFI状态、允许改变网络连接状态、读取手机状态</p>

    <p>iOS：手机设备类型、手机操作系统、硬件厂商、国际移动设备识别码、运营商类型、网络类型、sim卡数量、国际移动用户识别码、网络地址、屏幕尺寸、屏幕分辨率</p>

    <p>信息类型：个人常用设备信息</p>

    <p>共享方式：SDK本机采集</p>

    <p>使用目的：让移动用户可以一键登录账号</p>

    <p>第三方机构名称：中国移动</p>

    <p>隐私协议连接：https://wap.cmpassport.com/resources/html/contract.html</p>

    <p>官网链接：https://www.cmpassport.com/</p>

    <p>&nbsp;</p>

    <p><strong>联通 SDK</strong></p>

    <p>应用场景描述：一键登录</p>

    <p>收集的个人信息：</p>

    <p>Android：访问网络、网络信息状态、WIFI状态、允许改变WIFI状态、允许改变网络连接状态、读取手机状态</p>

    <p>iOS：网络类型、网络地址、运营商类型、本机手机号、国际移动用户标识码、sim卡数量、手机设备类型、手机操作系统、硬件厂商、屏幕尺寸、屏幕分辨率</p>

    <p>信息类型：个人常用设备信息</p>

    <p>共享方式：SDK本机采集</p>

    <p>使用目的：让联通用户可以一键登录账号</p>

    <p>第三方机构名称：中国联合网络通信有限公司</p>

    <p>隐私协议连接：https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true</p>

    <p>官网链接：http://www.chinaunicom.com.cn/index.html</p>

    <p>&nbsp;</p>

    <p><strong>电信 SDK</strong></p>

    <p>应用场景描述：一键登录</p>

    <p>收集的个人信息：</p>

    <p>Android：访问网络、网络信息状态、WIFI状态、允许改变WIFI状态、允许改变网络连接状态、读取手机状态</p>

    <p>iOS：网络类型、网络地址、运营商类型、本机手机号、国际移动用户标识码、sim卡数量、手机设备类型、手机操作系统、硬件厂商、屏幕尺寸、屏幕分辨率</p>

    <p>信息类型：个人常用设备信息</p>

    <p>共享方式：SDK本机采集</p>

    <p>使用目的：让电信用户可以一键登录账号</p>

    <p>第三方机构名称：中国联合网络通信有限公司</p>

    <p>隐私协议连接：https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true</p>

    <p>官网链接：https://id.189.cn/</p>

    <p>&nbsp;</p>

    <p><strong>极验 SDK</strong></p>

    <p>应用场景描述：一键登录</p>

    <p>收集的个人信息：</p>

    <p>Android：访问网络、网络信息状态、WIFI状态、读取手机状态</p>

    <p>iOS：网络类型、网络地址、运营商类型、本机手机号、国际移动用户标识码、sim卡数量、手机设备类型、手机操作系统、硬件厂商、屏幕尺寸、屏幕分辨率</p>

    <p>信息类型：个人常用设备信息</p>

    <p>共享方式：SDK本机采集</p>

    <p>使用目的：提供用户手机号一键登录功能</p>

    <p>第三方机构名称：武汉极意网络科技有限公司</p>

    <p>隐私协议连接：https://www.geetest.com/Service</p>

    <p>官网链接：<a href="https://www.geetest.com">https://www.geetest.com</a></p>

    <p>&nbsp;</p>

    <p><strong>友盟SDK</strong></p>

    <p>应用场景描述：统计分析、性能监测</p>

    <p>收集的个人信息：IMEI、MAC地址、android_id、OPENUDID、GUID、SIM卡IMSI、网络状态，idfa、电话状态</p>

    <p>信息类型：个人常用设备信息</p>

    <p>共享方式：SDK本机采集</p>

    <p>使用目的：应用崩溃信息统计</p>

    <p>第三方机构名称： 友盟同欣（北京）科技有限公司</p>

    <p>隐私协议连接：https://www.umeng.com/page/policy</p>

    <p>官网链接：https://www.umeng.com/</p>

    <p>&nbsp;</p>

    <p><strong>即构SDK</strong></p>

    <p>应用场景描述：开户视频录制和在线视频</p>

    <p>收集的个人信息：摄像头、麦克风、访问网络、网络信息状态、WIFI状态、读取手机状态</p>

    <p>信息类型：个人常用设备信息</p>

    <p>共享方式：SDK本机采集</p>

    <p>使用目的：提供在线开户视频功能支持</p>

    <p>第三方机构名称： 深圳市即构科技有限公司</p>

    <p>隐私协议连接：https://www.zego.im/privacy</p>

    <p>官网链接：https://www.zego.im</p>

    <p>&nbsp;</p>

    <p><strong>百度活体检测SDK</strong></p>

    <p>应用场景描述：开户人脸活体检测</p>

    <p>收集的个人信息：</p>

    <p>
      Android：设备信息（包括IMEI、IMSI、AndroidID、MAC地址、MEID、ICCID、OAID、运营商信息、WiFi状态、WiFi参数、WiFi列表、系统设置、系统属性、设备型号、操作系统、设备应用安装列表）、位置信息（通过IP地址解析获取粗略位置信息）、日志信息（包括设备信息和IP地址）、人脸图片、人脸视频信息（含语音）
    </p>

    <p>
      iOS：设备信息（包括IDFA、IDFV、运营商信息、WiFi状态、WiFi参数、系统设置、系统属性、设备型号、操作系统）、位置信息（通过IP地址解析获取粗略位置信息）、日志信息（包括设备信息和IP地址）、人脸图片、人脸视频信息（含语音）
    </p>

    <p>信息类型：个人常用设备信息</p>

    <p>共享方式：SDK本机采集</p>

    <p>使用目的：进行开户人脸活体检测流程</p>

    <p>第三方机构名称：北京百度网讯科技有限公司</p>

    <p>隐私协议连接：https://ai.baidu.com/ai-doc/REFERENCE/Vkdygjliz</p>

    <p>官网链接：官网链接：https://ai.baidu.com/mingjing</p>

    <p>&nbsp;</p>

    <p>&nbsp;</p>

    <p><strong>（三）我司收集个人信息的方式</strong></p>

    <p><strong>1.</strong><strong>我司为您提供服务时，您主动向我司提供的个人信息；</strong></p>

    <p><strong>2.</strong><strong>我司为您提供服务过程中形成的与服务相关的信息；</strong></p>

    <p><strong>3.</strong><strong>向征信机构、信用管理公司、资信评估机 构或有关法律、监管机构许可的类似机构采集您的信用信息和行为信息；</strong></p>

    <p><strong>4.</strong><strong>向政府机构、司法机关及公共事业单位
      </strong><strong>(</strong><strong>如人民银行、公安部、人力资源和社会保障部门、公积金管理中心、中国互联网金融协会等机构</strong><strong>)</strong><strong>采集与服务相关的必要信息，如您的身份证件信息、工商信息、税务信息、诉讼信息、社保信息等；</strong>
    </p>

    <p><strong>5.</strong><strong>经您授权，向合法留存您信息的自然人、法人以及其他组织收集与我司提供的服务相关的必要信息；</strong></p>

    <p><strong>6.</strong><strong>经您许可的其他方式。</strong></p>

    <p><strong>（四）我司如何使用个人信息</strong></p>

    <p><strong>1.</strong><strong>在向您提供我司的产品或服务，并为改进这些产品或服务时使用；</strong></p>

    <p>
      <strong>2.</strong><strong>在我司向您提供服务期间，您授权我司持续收集和使用您的信息。在您注销服务时，我司将停止收集您相关的个人信息，但我司会在业务资料归档、审计、监管协查等领域继续使用此前收集的您的相关个人信息；</strong>
    </p>

    <p><strong>3.</strong><strong>为提升您的产品或服务体验，或为防范风险，我司会对服务使用情况进行汇总、统计分析、加工，但这些信息不会包含您的任何身份识别信息；</strong></p>

    <p>
      <strong>4.</strong><strong>为了使您知悉使用我司产品或服务的情况或使您进一步了解我司服务，我司会向您发送服务状态通知以及相关产品或服务的商业性信息。如您不希望接受商业性信息，您有权退订，并要求我司停止为此项用途使用您的信息；</strong>
    </p>

    <p><strong>5.</strong><strong>将您的个人信息用于法律允许的</strong><strong>其它用途</strong><strong>。</strong></p>

    <p><strong>二、我司如何使用</strong><strong>Cookie</strong><strong>和同类技术</strong></p>

    <p><strong>（一）</strong><strong>Cookie</strong></p>

    <p>
      <strong>为确保网站正常运转，我司会在您的计算机或移动设备上存储名为</strong><strong>Cookie</strong><strong>的小数据文件。</strong><strong>Cookie</strong><strong>通常包含标识符、站点名称以及一些号码和字符。借助于</strong><strong>Cookie</strong><strong>，网站能够存储您的偏好或使用习惯等数据。我司不会将</strong><strong>Cookie</strong><strong>用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除</strong><strong>Cookie</strong><strong>。您可以清除计算机上保存的所有
      </strong><strong>Cookie</strong><strong>，大部分网络浏览器都设有阻止
      </strong><strong>Cookie</strong><strong>的功能。</strong><strong>但如果您这么做，则需要在每一次访问我司的网站时更改用户设置。</strong></p>

    <p>
      <strong>(</strong><strong>二</strong><strong>)</strong><strong>网站信标和像素标签除</strong><strong>Cookie</strong><strong>外，我司还会在网站上使用网站信标和像素标签等其他同类技术。例如，我司向您发送的电子邮件可能含有链接至我司网站内容的点击</strong><strong>URL</strong><strong>。如果您点击该链接，我司则会跟踪此次点击，帮助我司了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我司能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时退订。</strong>
    </p>

    <p><strong>(</strong><strong>三</strong><strong>)Do Not Track(</strong><strong>请勿追踪</strong><strong>)</strong></p>

    <p><strong>很多网络浏览器均设有</strong><strong>Do Not Track</strong><strong>功 能，该功能可向网站发布</strong><strong>Do Not
        Track</strong><strong>请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了</strong><strong>Do Not
        Track</strong><strong>，那么我司的所有网站都会尊重您的选择。</strong></p>

    <p><strong>（四）日志信息</strong></p>

    <p>
      <strong>在您访问我们的网站或使用我们的服务时，我们可能会收集日志信息，包括上文所述设备或应用信息、位置信息、点击流数据、应用情况以及您通过我们的服务分享的内容所包含的信息</strong><strong>(</strong><strong>元数据</strong><strong>)</strong><strong>，用于互联网信息安全的监管要求，避免对用户的合法权益造成损害。其次，我们会在进行特殊处理且无法定位到特定用户后用于数据分析来改善产品服务即用户体验。我司不会将其用于本政策所述目的之外的任何用途。</strong>
    </p>

    <p><strong>三、关于存储和对外提供您的个人信息</strong></p>

    <p><strong>(</strong><strong>一</strong><strong>)</strong><strong>存储</strong></p>

    <p>
      <strong>1.</strong><strong>我司在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。但为处理跨境业务并在获得您的授权同意后，您的个人信息可能会被转移到境外。此种情况下，我司会采取有效措施保护您的信息安全，例如，在跨境数据转移之前实施数据去标识化等安全措施，或通过协议、核查等措施要求境外机构为您的信息保密。</strong>
    </p>

    <p><strong>2.</strong><strong>我司仅在法律法规要求的期限内，以及为实现本政策声明的目的所必须的期限内，确定单个用户数据的最长储存期限以及用户日志的储存期限。</strong></p>

    <p><strong>(</strong><strong>二</strong><strong>)</strong><strong>共享</strong></p>

    <p><strong>我们不会与任何第三方公司、组织和个人共享您的个人信息。以下情况除外：</strong></p>

    <p><strong>1</strong><strong>、在获取</strong><strong>明确同意</strong><strong>的情况下共享，获得您的同意后，我们会与其他方共享您的个人信息。</strong></p>

    <p><strong>2</strong><strong>、我们可能会根据法律法规规定，或按政府主管部门的</strong><strong>强制性要求</strong><strong>，对外共享您的个人信息。</strong>
    </p>

    <p>
      <strong>3</strong><strong>、</strong><strong>合作方共享</strong><strong>：为了向您提供更完善、优质的产品和服务，我们的某些服务将由合作方提供，我们可能会与合作方共享您的某些个人信息，以提供更好的服务和用户体验。我们仅会处于合法、正当、必要特定、明确的目的共享您的个人信息，并且只会共享提供我们服务所必要的个人信息并于合作方签署严格的保密协议。合作方无权将共享的个人信息用于其他任何用途。例如，我们可能会使用间接用户画像与合作方共享，并仅提供推广覆盖面和有效性的信息，不会提供您的个人身份信息。</strong>
    </p>

    <p>
      <strong>4</strong><strong>、</strong><strong>与我们的经营机构及关联公司的共享</strong><strong>：您的个人信息可能会在我们的各经营机构及关联公司内部共享。我们只会共享必要的个人信息，且这种共享受本协议所声明目的的约束。一旦改变个人信息的处理目的，我们将会再次征求您的授权同意。共享个人信息的范围将根据具体业务情况而定，如向您发售、提供及营销财通及其关联公司的产品</strong><strong>/</strong><strong>服务，以及监管、维持、管理及操作有关产品</strong><strong>/</strong><strong>服务，可能在我们的各经营机构及关联公司内部共享您的个人身份信息及账户信息。</strong>
    </p>

    <p><strong>&nbsp;(</strong><strong>三</strong><strong>)</strong><strong>公开披露</strong></p>

    <p>我们不会公开披露您的个人信息。如在活动中披露中奖名单，我们会进行脱敏展示中奖手机号或用户名。但以下情况除外：</p>

    <p>1、获得您的明确同意；</p>

    <p>2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>

    <p><strong>（四）根据相关法律法规及国家标准，在以下情形中，我们可能会依法共享、转让、公开披露您的个人信息无需征得您的同意：</strong></p>

    <p>1、与国家安全、国防安全直接相关的；</p>

    <p>2、与公共安全、公共卫生、重大公共利益直接相关的；</p>

    <p>3、与犯罪侦查、起诉、审判、和判决执行等直接相关的；</p>

    <p>4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>

    <p>5、您自行向社会公众公开的个人信息；</p>

    <p>6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>

    <p><strong>四、我司如何保护您的个人信息</strong></p>

    <p>
      (一)我司已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。我司会采取一切合理可行的措施，保护您的个人信息。例如：我司会使用加密技术确保数据的保密性；我司会使用受信赖的保护机制防止数据遭到恶意攻击；我司会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我司会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
    </p>

    <p>
      <strong>(</strong><strong>二</strong><strong>)</strong><strong>请您理解，由于技术水平局限以及可能存在的恶意攻击，有可能出现我司无法合理预见、防范、避免、控制的意外情况。互联网并非绝对安全的环境，请使用复杂密码，协助我司保证您的账号安全。</strong>
    </p>

    <p>(三)如发生个人信息安全事件，我司将按照法律法规的要求，及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，或采取合理、有效的方式发布公告。同时，我司还将依据监管规定，上报个人信息安全事件处置情况。</p>

    <p>
      (四)如何处理未成年人的个人信息。我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人与他们的父母或监护人阅读本政策，在未成年人提交个人信息之前寻求父母或监护人的同意和指导。但是，如果您确认自己能够完全理解本政策的全部内容且您为使用财通证券服务所进行的相关操作行为与您的年龄、智力相适应的，则您可以独立进行相关操作(包括向我们提交您的个人信息)。
    </p>

    <p>
      <strong>(</strong><strong>五</strong><strong>)</strong><strong>我司个人信息保护由我司系统运维部负责，</strong><strong>&nbsp;</strong><strong>位于浙江省杭州市，联系方式</strong><strong>95336</strong><strong>。</strong>
    </p>

    <p><strong>五、您控制个人信息的权利</strong></p>

    <p>按照中国相关的法律法规和监管规定，我司保障您对自己的个人信息行使以下权利：</p>

    <p>（一）访问、更正及更新您的个人信息</p>

    <p>您有权通过我司官方网站、手机APP等渠道访问及更正、更新您的个人信息，法律法规另有规定的除外。您有责任及时更新您的个人信息。</p>

    <p>（二）删除您的个人信息</p>

    <p>在以下情形中，您可以向我司提出删除个人信息的请求：</p>

    <p>1、如果我司处理个人信息的行为违反法律法规；</p>

    <p>2、如果我司收集、使用您的个人信息，却未征得您的同意；</p>

    <p>3、如果我司处理个人信息的行为违反了与您的约定。</p>

    <p>
      4、如果您不想继续使用我们的产品或服务，或您主动注销了手机账户，在注销后，除法律另有规定外我们将及时停止收集您个人信息的活动，您在企财通账户下的个人信息将进行删除或匿名化处理，且此前和财通证券手机账户关联的相关产品和服务内容也将被删除。我司承诺5个工作日内删除您的账户相关数据。
    </p>

    <p>（三）响应您的上述请求</p>

    <p>
      为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我司可能会先要求您验证自己的身份，然后再处理您的请求。请您理解，对于某些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我司可能会予以拒绝。
    </p>

    <p><strong>尽管有上述约定，但按照法律法规要求，</strong><strong>&nbsp;</strong><strong>如涉及以下情形我司将可能无法响应您的请求：</strong></p>

    <p>1、与国家安全、国防安全相关的；</p>

    <p>2、与公共安全、公共卫生、重大公共利益相关的；</p>

    <p>3、与犯罪侦查、起诉、审判和判决执行等相关的；</p>

    <p>4、有充分证据表明您存在主观恶意或滥用权利的；</p>

    <p>5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>

    <p>6、涉及我司商业秘密的。</p>

    <p><strong>六、本政策如何更新</strong></p>

    <p>
      财通企财通APP的所有服务均适用于本政策，除非相关服务已有独立的隐私权政策或相应的用户协议当中存在特殊约定。我们保留不时更新或修改本政策的权利。未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会通过推送通知、弹窗、官网公告等合理方式通知您，以便您能够及时了解本政策所做的任何变更（包括业务功能变更、使用目的变更等）。若您不同意该变更可以停止使用财通证券移动应用产品和服务或通过95336客户服务热线、营业部现场反馈与我们联系，若您继续使用我们的产品或服务，即表示您同意接受修订后的本政策约束。
    </p>

    <p>当本政策发生重大变更时，视具体情况，我们还会提供更为显著的通知，说明本政策具体变更内容。本政策所指的重大变更包括但不限于：</p>

    <p>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>

    <p>2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>

    <p>3、个人信息共享、转让或公开披露的主要对象发生变化；</p>

    <p>4、您参与个人信息处理方面的权利及其形式方式发生重大变化；</p>

    <p>5、我们负责客户数据保护及公民个人信息保护的责任部门、联络方式及投诉渠道发生变化时；</p>

    <p>6、个人信息安全影响评估报告表明存在高风险时。</p>

    <p><strong>七、如何联系我司</strong></p>

    <p><strong>如果您对本隐私政策有任何疑问、意见或建议，请联系我司客服热线</strong><strong>95336</strong><strong>。</strong><strong>&nbsp;</strong>
    </p>

    <p>
      <strong>请您在同意之前仔细阅读本隐私政策，确保对其内容特别是字体加黑内容的含义及相应法律后果已全部知晓并充分理解。您同意并完成注册程序即视为您接受本隐私政策，我司将按照相关法律法规及本政策来合法使用和保护您的个人信息。</strong>
    </p>

    <p>&nbsp;</p>

    <p><strong>附录</strong><strong>1</strong><strong>、《</strong><strong>APP</strong><strong>收集个人信息清单》</strong></p>

    <p><strong>一、用户基本信息</strong></p>

    <p><strong>个人姓名</strong></p>

    <p>使用目的：实名认证、开户认证、信息展示</p>

    <p>使用场景：证券账户开户，账号首次登录实名认证，首页和个人中心页面展示。</p>

    <p><strong>&nbsp;</strong></p>

    <p><strong>电话号码</strong></p>

    <p>使用目的：注册，登录</p>

    <p>使用场景：用手机号登录，用手机号注册。</p>

    <p><strong>&nbsp;</strong></p>

    <p><strong>二、用户身份证明</strong></p>

    <p><strong>身份证</strong></p>

    <p>使用目的：注销、注册相关认证</p>

    <p>使用场景：用户注销需要使用身份证信息进行实名比对，用户首次登录也需要进行身份证信息确认。</p>

    <p><strong>&nbsp;</strong></p>

    <p><strong>银行卡</strong></p>

    <p>使用目的：开户中绑定</p>

    <p>使用场景：开户过程中上传银行卡照片和卡号信息，用于绑定三方存管账户用途。</p>

    <p><strong>&nbsp;</strong></p>

    <p><strong>三、用户网络身份标识信息</strong></p>

    <p><strong>主体账号信息</strong></p>

    <p>使用目的：登录、用户设备识别</p>

    <p>使用场景：唯一设备识别码、硬件序列号、IMSI、MEID、Android_id、未知信息、完全的网络访问权限</p>

    <p><strong>&nbsp;</strong></p>

    <p><strong>网络地址</strong></p>

    <p>使用目的：网络请求、安全风控</p>

    <p>使用场景：账号安全风控、网络请求访问</p>

    <p><strong>&nbsp;</strong></p>

    <p><strong>四、设备属性信息</strong></p>

    <p><strong>唯一设备识别码</strong></p>

    <p>使用目的：安全风控、故障排查、兼容适配</p>

    <p>使用场景：设备安全风控、兼容性问题分析、性能分析</p>

    <p><strong>&nbsp;</strong></p>

    <p><strong>设备型号</strong></p>

    <p>使用目的：安全风控、故障排查、兼容适配</p>

    <p>使用场景：设备安全风控、兼容性问题分析、性能分析</p>

    <p><strong>&nbsp;</strong></p>

    <p><strong>日志信息</strong></p>

    <p><strong>操作日志</strong></p>

    <p>使用目的：故障排除</p>

    <p>使用场景：根据上报的错误信息排除错误</p>

    <p>&nbsp;</p>

    <p><strong>附录</strong><strong>2</strong><strong>、《</strong><strong>APP</strong><strong>系统权限和使用清单》</strong></p>

    <p>1.为保障财通企财通能实现与安全稳定运行之目的，我们可能会申请或使用操作系统的相关权限；</p>

    <p>2.为保障您的知情权，我们通过下列列表将产品可能申请、使用的相关操作系统权限进行展示，您可以根据实际需要对相关权限进行管理；</p>

    <p>3.根据产品的升级，申请、使用权限的类型与目的可能会有变动，我们将及时根据这些变动对列表进行调整，以确保您及时获悉权限的申请与使用情况；</p>

    <p>4.请您知悉，我们为业务与产品的功能与安全需要，我们可能也会使用第三方SDK，这些第三方也可能会申请或使用相关操作系统权限；</p>

    <p>5.在使用产品的过程中，您可能会使用第三方开发的H5页面，这些第三方开发开发的插件也可能因业务功能所必需而申请或使用相关操作系统权限;</p>

    <p>一、安卓操作系统应用权限列表</p>

    <p>1.读取SD卡中的内容（读取存储空间/照片权限）android.permission.READ_EXTERNAL_STORAGE</p>

    <p>权限功能说明：提供读取手机储存空间内数据的功能</p>

    <p>使用场景与目的：允许App读取存储中的图片、文件等内容，主要用于帮助您在开户过程中上传图片、文件等内容进行资料审核、在本地记录崩溃日志信息等功能</p>

    <p>&nbsp;</p>

    <p>2.写入/删除SD卡中的内容（写入/删除/存储空间/照片权限）android.permission.WRITE_EXTERNAL_STORAGE</p>

    <p>权限功能说明：提供写入外部储存功能</p>

    <p>使用场景与目的：允许App写入/下载/保存/缓存/修改/删除图片、文件、崩溃日志等信息</p>

    <p>&nbsp;</p>

    <p>3.读取手机状态和身份（电话权限、设备权限）android.permission.READ_PHONE_STATE</p>

    <p>权限功能说明：提供读取手机设备标识等信息，请您放心该权限无法监听、获取您的任何通话内容与信息</p>

    <p>使用场景与目的：读取设备标识信息，识别设备ID，用于完成账号登录、安全保障等主要功能</p>

    <p>&nbsp;</p>

    <p>4.访问大致地理位置信息 android.permission.ACCESS_COARSE_LOCATION</p>

    <p>权限功能说明：通过网络位置信息（例如基站和WLAN）获取大致地理位置信息</p>

    <p>使用场景与目的：用于完成安全保障服务及基于地理位置的服务（LBS）如：同城信息、发布作品坐标定位以及小程序需使用相关位置服务等相关功能</p>

    <p>&nbsp;</p>

    <p>5.访问精确地理位置信息 android.permission.ACCESS_FINE_LOCATION</p>

    <p>权限功能说明：通过全球定位系统（GPS）和网络位置信息（例如基站和WLAN）获取精准地理位置信息</p>

    <p>使用场景与目的：用于完成安全保障服务及基于地理位置的服务（LBS）如：同城信息、发布作品坐标定位以及小程序需使用相关位置服务等相关功能</p>

    <p>&nbsp;</p>

    <p>6.录音 android.permission.RECORD_AUDIO</p>

    <p>权限功能说明：使用麦克风录制音频</p>

    <p>使用场景与目的：用于帮助您完成开户问题音频录制功能，需要使用该权限的相关功能</p>

    <p>&nbsp;</p>

    <p>7.拍摄照片和视频 android.permission.CAMERA</p>

    <p>权限功能说明：使用拍摄照片和视频、完成扫描二维码</p>

    <p>使用场景与目的：用于帮助您完成开户视频录制、完成扫描二维码等需要使用该权限的相关功能</p>

    <p>&nbsp;</p>

    <p>二、iOS操作系统应用权限列表</p>

    <p>1.NSPhotoLibraryAddUsageDescription</p>

    <p>权限功能说明：向相册中添加内容</p>

    <p>使用场景和目的：允许App写入/下载/保存/修改/删除图片、文件、崩溃日志等信息</p>

    <p>&nbsp;</p>

    <p>2.NSPhotoLibraryUsageDescription</p>

    <p>权限功能说明：读取相册中内容</p>

    <p>使用场景和目的：允许App读取存储中的图片、文件等内容，主要用于帮助您在开户过程中上传各类证件照片时使用。</p>

    <p>&nbsp;</p>

    <p>3.NSCameraUsageDescription</p>

    <p>权限功能说明：使用摄像头</p>

    <p>使用场景和目的：用于帮助您完成开户过程中的视频拍摄、完成扫描二维码等需要使用该权限的相关功能。</p>

    <p>&nbsp;</p>

    <p>4.NSLocationWhenInUseUsageDescription</p>

    <p>权限功能说明：仅App被使用时获取地理位置</p>

    <p>使用场景和目的：用于完成安全保障、最近营业部推荐等基于地理位置服务（LBS）相关功能</p>

    <p>&nbsp;</p>

    <p>5.NSMicrophoneUsageDescription</p>

    <p>权限功能说明：使用麦克风</p>

    <p>使用场景和目的：用于帮助您完成开户过程中的音频录制等需要使用该权限的相关功能</p>

    <p>&nbsp;</p>

    <p>6.NSFaceIDUsageDescription</p>

    <p>权限功能说明：使用面容ID</p>

    <p>使用场景和目的：用于用户账号登录验证功能。</p>

    <p>&nbsp;</p>

    <p>7.NSUserTrackingUsageDescription</p>

    <p>权限功能说明：获取设备标识，以识别设备信息</p>

    <p>使用场景和目的：仅用于标识设备，保障服务安全。</p>

    <p>&nbsp;</p>

    <p>8.NSLocationTemporaryUsageDescriptionDictionary</p>

    <p>权限功能说明：允许临时访问精确地理位置信息</p>

    <p>使用场景和目的：用于完成安全保障、最近营业部推荐等基于地理位置服务（LBS）相关功能</p>

    <p>&nbsp;</p>

    <p>&nbsp;</p>

  </div>
</template>

<script>
  document.title = "财通企财通隐私政策";
  export default {
    name: "QctServiceProtocal",
    mounted: function () {
      sensors.track('qctPrivateProtocal', Object.assign({}, {
        platform_type: 'H5',
        platform_name: '企财通',
        client_id: 'aaa'
      }, {}))
    },
    data: function () {
      return {
        // uaInfo: "",
      };
    },
  };
</script>

<style scoped>
  .content {
    padding: 60px;
  }
</style>